import { Injectable } from '@angular/core';

@Injectable()
export class TokenService {
	private _token: string = '';
	private _checkOutToken: string = '';
	private _isTokenATerminalID: boolean = false;
	public  terminalTokenVersion = "V1";

	constructor() {}

	get token(): string {
		return this._token;
	}

	set token(token: string) {
		// console.log('token: token service--->', token);
		if (typeof token === 'string' &&
			token.length === 26 &&
			token.toUpperCase().endsWith(this.terminalTokenVersion)) {
			// Return the first 24 characters (from start to index 23)
			this._token = token.slice(0, 24);
			this._isTokenATerminalID = true;
		} else {
			this._token = token;
			this._isTokenATerminalID = false;
		}

	}
	
	get checkOutToken(): string {
		return this._checkOutToken;
	}

	set checkOutToken(token: string) {
		// console.log('token: token service--->', token);
		this._checkOutToken = token;
	}

	get isTokenATerminalID(): boolean {
		return this._isTokenATerminalID;
	}
}
